import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../../filter/filter.model';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-view-signed-contracts',
  templateUrl: './view-signed-contracts.component.html',
  styleUrls: ['./view-signed-contracts.component.scss']
})
export class ViewSignedContractsComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public count!:any;
  public signedArr: any[] = []
  public isSpinnerLoading:boolean=false;
  public filterObj:Filter={
    operand:"or",
    arr:[]
  }
  public filterArr:any[]=[
    { key_name: "First Name", key_val: "f_n", type: 'text' },
    { key_name: "Last Name", key_val: "l_n", type: 'text' },
    // { key_name: "Department", key_val: "department", type: 'select' },
  ]
  public displayedColumns: string[] = ['employee_info', 'signed_time',  'download'];

  public dataSource = new MatTableDataSource();
  
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, private spinner: NgxSpinnerService, private appService: AppService,
    public dialogRef: MatDialogRef<ViewSignedContractsComponent>, private docService: DocumentService,private commonService:CommonService) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.getSignedContractList()
    this.onPageChange(1)
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.getSignedContractList()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.getSignedContractList()
  }
  getSignedContractList() {
    let obj = {
      doc_id: this.dialogData.id,
      start: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      rowperpage: this.config.itemsPerPage,
      search: "",
      operand:this.filterObj.operand,
      filter_arr: this.filterObj.arr,
    }
    this.isSpinnerLoading=true
    this.docService.viewSignedContract(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          // this.contractArr = [];
          this.signedArr=[]
           this.signedArr= success["data"]["signed_list"];
           this.dataSource.data=success["data"]["signed_list"];
            this.count = success.data.count;
        }
      },
      error: (error: any) => {
         this.isSpinnerLoading = false;
       this.commonService.handleError(error);
      },
    });
  }
  onDownload(item){
    this.appService.downloadFile(item.base_url+item.doc_name,'contract')
  }
}
